import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { Card, Col, Row, Statistic } from "antd";

import LoadingPage from "../../components/LoadingPage";
import Error404Page from "../../components/Error404Page";

import { getRobotPLCAlarms } from "../alarms/alarmSlice";
import AlarmList from "../alarms/AlarmList";

const RobotHealth = () => {
  const { robotName } = useParams();
  const robotId =
    robotName && robotName.match(/(\d+)/) && robotName.match(/(\d+)/)[0];

  const robots = useSelector((state) => state.robot.robots);
  const alarms = useSelector((state) => state.alarms.alarms);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getRobotPLCAlarms(robotId));
  }, [dispatch, robotId]);

  if (!robotId) {
    return <Error404Page />;
  }

  if (!robots) {
    return <LoadingPage />;
  }
  if (!alarms) {
    return <LoadingPage />;
  }
  const robot = robots.find((item) => item.name === robotName);

  const parseAlarms = (plcAlarms, systemAlarms) => {
    return [
      ...systemAlarms
        .map((item, index) => {
          if (robotName === item.name && item.summary && item.summary.data) {
            const coreFiles =
              parseInt(item.summary.data[0].core_files, 10) || null;
            if (coreFiles > 0) {
              return {
                key: "sys" + index,
                unit: item.name,
                message: `System crashed ${coreFiles} times`,
                type: "crash",
                received_at: item.summary.date,
                detail: "Please contact customer to investigate.",
              };
            } else {
              return null;
            }
          } else {
            return null;
          }
        })
        .filter((item) => item),

      ...systemAlarms
        .map((item, index) => {
          if (robotName === item.name && item.space) {
            const usedSpace = item.space
              ? (parseInt(item.space.used, 10) /
                  parseInt(item.space.total, 10)) *
                100
              : null;
            if (usedSpace > 75) {
              return {
                key: "ipc" + index,
                unit: item.name,
                message: `${item.space.free} disk space left`,
                type: usedSpace > 90 ? "error" : "warning",
                received_at: item.summary.date,
                detail: "Please contact customer to free up the space.",
              };
            } else {
              return null;
            }
          } else {
            return null;
          }
        })
        .filter((item) => item),

      ...plcAlarms.map((item, index) => {
        return { key: "plc" + index, ...item };
      }),
    ];
  };

  const data = parseAlarms(alarms, robots);

  const statsData = {
    warning: data.filter((item) => item.type === "warning").length || 0,
    error: data.filter((item) => item.type === "error").length || 0,
    crash: data.filter((item) => item.type === "crash").length || 0,
  };
  return (
    <>
      <Row gutter={16}>
        <Col span={8}>
          <Card title="" bordered={false}>
            <Statistic
              title={"Error"}
              value={statsData.error.length}
              valueStyle={{ color: "red" }}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card title="" bordered={false}>
            <Statistic
              title={"Warning"}
              value={statsData.warning.length}
              valueStyle={{ color: "orange" }}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card title="" bordered={false}>
            <Statistic
              title={"Crash"}
              value={statsData.crash.length}
              valueStyle={{ color: "red" }}
            />
          </Card>
        </Col>
      </Row>
      <AlarmList alarms={data} />
    </>
  );
};

export default RobotHealth;
